import React from "react";
import "./Nebula.css";
import PageHeader from "../../../components/headers/PageHeader";
import wave from "../../../assets/Images/waves/mix_wave.jpg";

export default function Nebula() {
    return (
        <div className="nebula-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="RBQM Intelligence Platform"
                title="Nebula™"
            />

            <section className="nebula-section">
                <h2>AI-enabled oversight for risk-based clinical trial execution</h2>

                <article className="nebula-box">
                    <p>
                        Nebula™ is an AI-enabled Risk-Based Quality Management platform
                        designed to help clinical operations teams detect risk earlier,
                        monitor study performance more intelligently, and manage trials
                        with proactive execution control.
                    </p>
                </article>
            </section>

            <section className="nebula-section">
                <h2>Purpose of Nebula™</h2>

                <article className="nebula-box">
                    <p>
                        Clinical trials generate operational signals across sites,
                        vendors, safety, data management, monitoring, enrollment, and
                        protocol compliance. Nebula™ brings these signals into a
                        structured oversight environment so teams can identify emerging
                        risks before they become major quality or execution issues.
                    </p>

                    <ul className="nebula-list">
                        <li>Support proactive study oversight instead of reactive tracking</li>
                        <li>Identify site-level and study-level risks earlier</li>
                        <li>Monitor Key Risk Indicators across the trial lifecycle</li>
                        <li>Improve visibility into enrollment, deviations, and data quality</li>
                        <li>Support risk review meetings and governance documentation</li>
                    </ul>
                </article>
            </section>

            <section className="nebula-section">
                <h2>Core Capabilities</h2>

                <div className="nebula-boxGrid">
                    <article className="nebula-box">
                        <h3>KRI Monitoring</h3>
                        <p>
                            Track Key Risk Indicators related to site performance,
                            enrollment trends, protocol deviations, query burden,
                            missing data, monitoring findings, and operational quality.
                        </p>
                    </article>

                    <article className="nebula-box">
                        <h3>Centralized Monitoring</h3>
                        <p>
                            Consolidate trial signals into centralized dashboards that
                            support risk detection, prioritization, review, and
                            escalation planning.
                        </p>
                    </article>

                    <article className="nebula-box">
                        <h3>Site Performance Intelligence</h3>
                        <p>
                            Compare site behavior across enrollment, retention,
                            deviations, data quality, responsiveness, and operational
                            execution metrics.
                        </p>
                    </article>

                    <article className="nebula-box">
                        <h3>Risk Signal Escalation</h3>
                        <p>
                            Support structured escalation pathways, issue ownership,
                            corrective action tracking, and governance-level review.
                        </p>
                    </article>
                </div>
            </section>

            <section className="nebula-section">
                <h2>Study Oversight Areas</h2>

                <article className="nebula-box">
                    <ul className="nebula-list">
                        <li>Enrollment rate tracking and forecasting</li>
                        <li>Site activation and start-up progress monitoring</li>
                        <li>Protocol deviation trend analysis</li>
                        <li>Query volume and data cleaning performance review</li>
                        <li>Patient dropout and retention monitoring</li>
                        <li>Vendor and CRO performance oversight</li>
                        <li>Monitoring visit findings and follow-up tracking</li>
                        <li>Corrective and preventive action visibility</li>
                    </ul>
                </article>
            </section>

            <section className="nebula-section">
                <h2>Why Nebula™</h2>

                <article className="nebula-box">
                    <p>
                        Traditional monitoring models often rely heavily on periodic
                        visits and retrospective review. Nebula™ helps teams move
                        toward targeted oversight by using structured risk signals,
                        performance analytics, and centralized review models.
                    </p>

                    <ul className="nebula-list">
                        <li>Reduces dependence on traditional 100% SDV-driven oversight</li>
                        <li>Helps clinical operations teams prioritize risk areas</li>
                        <li>Improves visibility across sites, vendors, and study functions</li>
                        <li>Supports inspection-ready RBQM documentation and traceability</li>
                        <li>Strengthens proactive trial execution control</li>
                    </ul>
                </article>
            </section>
        </div>
    );
}